var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminApp',[_c('div',{staticClass:"UsersDashboard d-flex flex-column w-100 align-items-center"},[_c('UsersPanel',{staticClass:"UsersDashboard__Panel mx-3"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }